const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    // LDF: als App (Home-Bildschirm) reicht die Seite bis unter die Statusleiste – Abstand über safe-area
    <header
      className="fixed top-0 left-0 right-0 z-10 bg-secondary px-4 w-full flex justify-between items-center"
      style={{ paddingTop: "var(--ldf-top)", height: "calc(3.5rem + var(--ldf-top))" }}
    >
      {children}
    </header>
  );
};

export default MobileHeader;
